import { render, staticRenderFns } from "./MapNavigation.vue?vue&type=template&id=1477874e&scoped=true"
import script from "./MapNavigation.vue?vue&type=script&lang=js"
export * from "./MapNavigation.vue?vue&type=script&lang=js"
import style0 from "./MapNavigation.vue?vue&type=style&index=0&id=1477874e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1477874e",
  null
  
)

export default component.exports